module.exports = "https://www.gc-qa.gnp.com.mx/fc673dd6ab6946f4af7cdf65b8df7656.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/amex-card.png
// module id = 1796
// module chunks = 0